import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form,  Button , NavLink, Card ,Container,Modal,Spinner ,Breadcrumb,Row,Col } from 'react-bootstrap';
import React from 'react';
import axios from 'axios';
import QRCode  from 'qrcode-react'


class FlexProductPay extends React.Component {
  constructor(props) {
    super(props);

    console.log(window);
    if(window.location.hostname!=="localhost"){
      //hao.zhongdaiqi.com ->  hmb.zhongdaiqi.com
      if(window.location.hostname==="hao.zhongdaiqi.com"){
          //确保是https
          if(window.location.protocol==="http:"){
            console.log("自动跳转到https 确保用户数据安全");  
            window.location.href=window.location.href.replace("http://hao.zhongdaiqi.com","https://hmb.zhongdaiqi.com")
          }else{
            window.location.href=window.location.href.replace("https://hao.zhongdaiqi.com","https://hmb.zhongdaiqi.com")
          }
      }

      //确保是https
      if(window.location.protocol==="http:"){
        console.log("自动跳转到https 确保用户数据安全");  
        window.location.href=window.location.href.replace("http://","https://")
      }
    }

    var u=props.match.params.u;
    if(!u){
      //先尝试从本地缓存读取
      try {
        //尝试读取本地追踪标
        var local_u = localStorage.getItem("u");//获取存储的元素
        if(local_u){
          console.log("本地缓存有追踪标，重置默认推广员");
          u = local_u;
        }else{
          u="zuime";
        }
      }
      catch(err) {
        console.log("读取追踪标出现了异常");
        u="zuime";//使用默认标
      }
    
    }else{
      //写入本地缓存
      try {
        //写入本地永久缓存
        localStorage.setItem("u",u);//写入本地 追踪标
      }
      catch(err) {
        console.log("写入本地追踪标出现了异常");
      }
    }

    console.log("ua信息---开始aaa");
    const ua =  window.navigator.userAgent.toLowerCase();
    const isWeixin = ua.indexOf('micromessenger') !== -1;

    try {
            //验证环境
           
            console.log("ua信息---开始");
            console.log(ua);
            console.log("ua信息---结束");
            console.log(isWeixin);
            let debugdata = new FormData();
            debugdata.append('msg',"支付Agent："+ua);

            axios.post("/lkjapi/msg.php",debugdata)
            .then(function () {
              

            });

    } catch(err) {
      console.log("ua debug异常");
    }

    this.state = {
      product:{

      },
      u:u,
      showBtn:true,
      orderCode:props.match.params.ordercode,
      token:props.match.params.token,
      isWeixin:isWeixin
    };

   

 
     

    

}






 



  render() {
 
   return  <div className="App">


          <Container>
        
          <Breadcrumb>
            <Breadcrumb.Item href={"#/cha?u="+this.state.u}>
               查单
            </Breadcrumb.Item>

            <Breadcrumb.Item active>提醒</Breadcrumb.Item>
          </Breadcrumb>

 
             <div style={{margin:'20px'}}>下单成功，您的订单审核中</div>


            <div style={{ display: this.state.isWeixin?'block':'none'}}>
            <NavLink href={ "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx72668bf92c24aaab&response_type=code&scope=snsapi_base&state=haomabao&redirect_uri="+    encodeURIComponent("https://hmb.zuime.com/oauth/wx?redirect="+encodeURIComponent("https://hmb.zuime.com/hopeapi/order/wxpay?orderCode="+this.state.orderCode+"&token="+this.state.token))+"#wechat_redirect"  }>
                <button  type="button" className="btn btn-success btn-lg btn-block  "> 微信在线付款</button>
              
             </NavLink>
            </div>

         
          
           <Card body className="mt-3"><img src="haomabaoqrcode.png"  style={{width:"100%"}}></img></Card>
       
 
            <Card body className="mt-3"  style={{textAlign:"left"}}>
         
            </Card>
        </Container>
       
    </div>
  }
}

export default FlexProductPay;
